import seoSettings from './seoSettings'
import urlReturnSettings from './urlReturnSettings'

export default {
  urlReturnSettings,
  seoSettings,
}
